import { styled } from '@mui/system';
import { brandonGrotesqueBold } from './theme';
import { Typography, Tabs, Container, Grid2, Box } from '@mui/material';

export const PlaceholderGrid = styled(Grid2)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
  background: theme?.palette?.buttonFontColor,
  borderRadius: '0.9375rem'
}));

export const ContainerTop = styled(Container)`
  @media (min-width: 768px) {
    padding: 100px 59px !important;
  }
`;
export const ContainerStyled = styled(Container)`
  padding: 1rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f2f2f2;
  min-height: 700px;
  min-width: 500px;
  width: 500px;
  border-radius: 0.9375rem;
  box-shadow: 0px 0px 1.875rem 0px rgba(0, 79, 113, 0.2);
  position: relative;

  @media (max-width: 767px) {
    min-width: 100%;
    width: 100%;
    padding: 0.5rem;
    margin: 50px;
  }
`;

export const CutOffIcon = styled(Box)(({ theme }) => ({
  width: '45px',
  height: '45px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '0.3125rem solid #f2f2f2',
  position: 'relative',
  top: '1.875rem'
}));

export const TypographyH1 = styled(Typography)(({ theme }) => ({
  fontSize: '28.5pt',
  lineHeight: '38pt',
  fontWeight: 700,
  wordBreak: 'break-word',
  color: theme?.palette?.common?.black,
  fontFamily: brandonGrotesqueBold,
  fontStyle: 'normal'
}));

export const StyledTab = styled(Tabs)(({ theme }) => ({
  width: '-webkit-fill-available',
  border: '0.0625rem solid #D9D9D6',
  borderRadius: '100px',
  padding: '0.3125rem',
  '& .MuiTabs-indicator': {
    backgroundColor: theme?.palette?.common?.black,
    height: '0px'
  },
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    backgroundColor: theme?.palette?.buttonFontColor,
    borderRadius: '100px'
  },
  '& .MuiTab-root': {
    flex: 'auto',
    fontWeight: 450,
    fontFamily: 'BGbold !important',
    color: `${theme?.palette?.primaryDark} !important`,
    fontSize: '1rem',
    lineHeight: '1.375rem',
    textTransform: 'none'
  },
  '& .Mui-selected': {
    backgroundColor: theme?.palette?.lightBlue,
    color: `${theme?.palette?.buttonFontColor} !important`,
    borderRadius: '100px'
  }
}));

export const StyledTab2 = styled(Tabs)({
  width: '100%',
  borderRadius: '0.9375rem',
  '& .MuiTabs-indicator': {
    backgroundColor: '#000000',
    height: '0px'
  },
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    backgroundColor: '#5BC2E74D'
  },
  '& .MuiTab-root': {
    width: '50%',
    maxWidth: '50%',
    fontWeight: 450,
    fontFamily: 'BGbold !important',
    color: '#002A3A !important',
    fontSize: '1rem',
    lineHeight: '1.375rem',
    padding: '0.5rem 1rem',
    minHeight: '60px'
  },
  '& .Mui-selected': {
    backgroundColor: '#ffffff',
    color: '#002A3A !important'
  }
});
